/** How the payables ageing buckets read and colour, from settled to alarming. */
export const AGEING_BUCKETS: Array<{ key: string; label: string; colour: string }> = [
  { key: 'NOT_DUE', label: 'Not due', colour: '#105261' },
  { key: '1_30', label: '1–30 days', colour: '#18778B' },
  { key: '31_60', label: '31–60 days', colour: '#40B1C9' },
  { key: '61_90', label: '61–90 days', colour: '#F59E0B' },
  { key: '90_PLUS', label: '90+ days', colour: '#DC2626' },
];
